(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordions"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.faq__accordions details').forEach(function(faqAccordion) {
  faqAccordion.querySelector('summary').addEventListener('click', function(event) {
    if (event.target.parentNode.hasAttribute('open')) return;
    if (window.innerWidth < 768) {
      setTimeout(function() {
        window.scrollTo(0, event.target.getBoundingClientRect().top + window.scrollY - 90);
      }, 50);
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-v2"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('FaqV2Root');
  if (!root) return;

  var searchInput = root.querySelector('#FaqV2Search');
  var sections = Array.prototype.slice.call(root.querySelectorAll('.faq-v2__section-wrap'));
  var tocLinks = Array.prototype.slice.call(root.querySelectorAll('.faq-v2__toc-link'));
  var mobileTabs = Array.prototype.slice.call(root.querySelectorAll('.faq-v2__mobile-tab'));
  var noResults = root.querySelector('.faq-v2__no-results');
  var popularTags = Array.prototype.slice.call(root.querySelectorAll('.faq-v2__popular-tag'));

  var activeGroup = 'all';

  function normalize(str) {
    return str.toLowerCase().trim();
  }

  function update() {
    var query = searchInput ? normalize(searchInput.value) : '';
    var totalVisible = 0;

    sections.forEach(function (section) {
      var groupId = section.dataset.groupId;
      var groupMatch = (activeGroup === 'all' || activeGroup === groupId);

      var items = Array.prototype.slice.call(section.querySelectorAll('.faq-v2__item'));
      var sectionVisible = 0;

      items.forEach(function (item) {
        var matches = groupMatch && (!query || normalize(item.textContent).indexOf(query) > -1);
        item.hidden = !matches;
        if (matches) {
          sectionVisible++;
          totalVisible++;
        }
      });

      section.hidden = !groupMatch || (query.length > 0 && sectionVisible === 0);
    });

    if (noResults) {
      noResults.classList.toggle('is-visible', totalVisible === 0);
    }
  }

  function setActiveGroup(groupId) {
    activeGroup = groupId;
    tocLinks.forEach(function (l) {
      l.classList.toggle('is-active', l.dataset.group === groupId);
    });
    mobileTabs.forEach(function (t) {
      t.classList.toggle('is-active', t.dataset.group === groupId);
    });
    if (searchInput) searchInput.value = '';
    update();
  }

  tocLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      setActiveGroup(link.dataset.group);
    });
  });

  mobileTabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      setActiveGroup(tab.dataset.group);
    });
  });

  popularTags.forEach(function (tag) {
    tag.addEventListener('click', function () {
      setActiveGroup('all');
      if (searchInput) {
        searchInput.value = tag.dataset.tag;
        update();
        searchInput.focus();
      }
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', update);
  }

  update();
})();

  } catch(e) { console.error(e); }
})();
})();
